import Modal from "../../../../components/Modals/Modal";
import styled from "styled-components";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";

const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const selectSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "6px 10px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};

export default function ModalRoutePYM({
  open,
  onClose,
  form,
  setForm,
  saveRoutespym,
  empresasActivas,
  routesActive,
  groupsActive,
  subgroupsActive,
  consActive,
  routeSelected,
  groupSelected,
  getGroupByRoute,
  getSubGruposByGrupo,
  inputStyle
}) {
  if (!open) return null;

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={form.id ? "Editar RutaPYM" : "Crear RutaPYM"}
      width="900px"
    >
      {/* ================= FORMULARIO ================= */}
      <div style={{ display: "flex", gap: "20px", marginTop: "" }}>
        {/* ================= COLUMNA 1 ================= */}
        <div style={{ flex: 1 }}>
          <label>ID</label>
          <input disabled value={form.id || ""} style={inputStyle} />

          <label>Ruta</label>
          <SearchableSelect
            key={`modal-ruta-${routeSelected || "empty"}`}
            value={routeSelected ? String(routeSelected) : ""}
            onValueChange={(val) => getGroupByRoute(val)}
            options={routesActive.map((r) => ({
              value: String(r.id),
              label: `${r.codigo} - ${r.descripcion}`,
            }))}
            placeholder="Seleccione..."
            multiple={false}
            searchable={true}
            size="small"
            sx={{ mb: "12px", ...selectSx }}
          />

          <label>Inicial</label>
          <input
            type="number"
            value={form.Inicial}
            onChange={(e) => setForm({ ...form, Inicial: e.target.value })}
            style={inputStyle}
          />

          <label>Empresa</label>
          <SearchableSelect
            key={`modal-empresa-${form.id_empresa ?? 0}`}
            value={form.id_empresa !== undefined && form.id_empresa !== null ? String(form.id_empresa) : "0"}
            onValueChange={(val) =>
              setForm({ ...form, id_empresa: parseInt(val, 10) })
            }
            options={[
              { value: "0", label: "Seleccione..." },
              ...empresasActivas.map((emp) => ({
                value: String(emp.id),
                label: emp.nombre,
              })),
            ]}
            placeholder="Seleccione..."
            multiple={false}
            searchable={true}
            size="small"
            sx={{ mb: "12px", ...selectSx }}
          />

          <label>Sexo</label>
          <SearchableSelect
            key={`modal-sexo-${form.Sexo || "empty"}`}
            value={form.Sexo || ""}
            onValueChange={(val) => setForm({ ...form, Sexo: val })}
            options={[
              { value: "M", label: "M" },
              { value: "F", label: "F" },
              { value: "A", label: "A" },
            ]}
            placeholder="Seleccione..."
            multiple={false}
            searchable={false}
            size="small"
            sx={{ mb: "12px", ...selectSx }}
          />
        </div>

        {/* ================= COLUMNA 2 ================= */}
        <div style={{ flex: 1 }}>
          <label>Consecutivo</label>
          <SearchableSelect
            key={`modal-cons-${form.Consecutivo || "empty"}`}
            value={form.Consecutivo ? String(form.Consecutivo) : ""}
            onValueChange={(val) => setForm({ ...form, Consecutivo: val })}
            options={consActive.map((c) => ({
              value: String(c.Consecutivo),
              label: `${c.Consecutivo} - ${c.Api}`,
            }))}
            placeholder="Seleccione..."
            multiple={false}
            searchable={true}
            size="small"
            sx={{ mb: "12px", ...selectSx }}
          />

          <label>Grupo</label>
          <SearchableSelect
            key={`modal-grupo-${groupSelected || "empty"}`}
            value={groupSelected ? String(groupSelected) : ""}
            onValueChange={(val) => getSubGruposByGrupo(val)}
            disabled={!routeSelected}
            options={groupsActive.map((g) => ({
              value: String(g.id),
              label: `${g.codigo} - ${g.descripcion}`,
            }))}
            placeholder="Seleccione..."
            multiple={false}
            searchable={true}
            size="small"
            sx={{ mb: "12px", ...selectSx }}
          />

          <label>Final</label>
          <input
            type="number"
            value={form.Final}
            onChange={(e) => setForm({ ...form, Final: e.target.value })}
            style={inputStyle}
          />

          <label>Observaciones</label>
          <input
            value={form.Observaciones}
            onChange={(e) =>
              setForm({ ...form, Observaciones: e.target.value })
            }
            style={inputStyle}
          />
        </div>

        {/* ================= COLUMNA 3 ================= */}
        <div style={{ flex: 1 }}>
          <label>Orden</label>
          <input
            type="number"
            value={form.orden}
            onChange={(e) => setForm({ ...form, orden: e.target.value })}
            style={inputStyle}
          />

          <label>SubGrupo</label>
          <SearchableSelect
            key={`modal-subgrupo-${form.idSubGrupo || "empty"}`}
            value={form.idSubGrupo ? String(form.idSubGrupo) : ""}
            onValueChange={(val) => setForm({ ...form, idSubGrupo: val })}
            disabled={!groupSelected}
            options={subgroupsActive.map((sg) => ({
              value: String(sg.id),
              label: `${sg.codigo} - ${sg.descripcion}`,
            }))}
            placeholder="Seleccione..."
            multiple={false}
            searchable={true}
            size="small"
            sx={{ mb: "12px", ...selectSx }}
          />

          <label>Vigencia</label>
          <input
            type="number"
            value={form.Vigencia}
            onChange={(e) => setForm({ ...form, Vigencia: e.target.value })}
            style={inputStyle}
          />

          <label>Estado</label>
          <SearchableSelect
            key={`modal-estado-${form.estado ?? "1"}`}
            value={String(form.estado ?? "1")}
            onValueChange={(val) => setForm({ ...form, estado: val })}
            options={[
              { value: "1", label: "ACTIVO" },
              { value: "0", label: "INACTIVO" },
            ]}
            multiple={false}
            searchable={false}
            size="small"
            sx={{ mb: "12px", ...selectSx }}
          />
        </div>
      </div>
      <Row>
        <BtnGeneral
          bg="gray"
          padding="6px 10px"
          radius="6px"
          fw="600"
          onClick={onClose}
        >
          Cancelar
        </BtnGeneral>

        <BtnGeneral
          bg="green"
          padding="6px 10px"
          radius="6px"
          fw="600"
          onClick={saveRoutespym}
        >
          Guardar
        </BtnGeneral>
      </Row>
    </Modal>
  );
}
